import { useTranslation } from "react-i18next";
import { Form, Link } from "react-router";
import {
  Avatar,
  AvatarFallback,
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuLabel,
  DropdownMenuItem,
  DropdownMenuSeparator,
} from "ui";

import { useAuthContext } from "src/auth";

export function AuthMenu() {
  const authContext = useAuthContext();
  const { t } = useTranslation();

  const avatar = (
    <Avatar>
      <AvatarFallback className="uppercase">
        {authContext.store.initials}
      </AvatarFallback>
    </Avatar>
  );

  const logout = (
    <Form action="/logout" method="post">
      <DropdownMenuItem asChild>
        <button className="w-full cursor-pointer" type="submit">
          {t("logOut")}
        </button>
      </DropdownMenuItem>
    </Form>
  );

  const profileOption = (
    <DropdownMenuLabel className="flex gap-4 items-center">
      <div>{avatar}</div>
      <div className="flex flex-col">
        <span>{authContext.store.user.name}</span>
        <span className="text-xs font-normal">
          {authContext.store.user.email}
        </span>
      </div>
    </DropdownMenuLabel>
  );

  return (
    <DropdownMenu>
      <DropdownMenuTrigger>{avatar}</DropdownMenuTrigger>
      <DropdownMenuContent className="mr-4">
        {profileOption}
        <DropdownMenuSeparator />
        <DropdownMenuItem asChild>
          <Link className="capitalize" to="/settings">
            {t("settings")}
          </Link>
        </DropdownMenuItem>
        {logout}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
